import React, { useState } from 'react';
import PatientsGroupsFilter from '../PatientsGroupsFilter/PatientsGroupsFilter';
import PatientsGroupsList from '../PatientsGroupsList/PatientsGroupsList';
import { useLazyGroupsQuery } from '../../../../graphql/graphql';
import useGroups from '../../Hooks/useGroups';
import useFlatData from '../../../Base/Hooks/useFlatData';
import Button from '../../../../Components/Button/Button';
import { Theme } from '../../../../Enums/Theme.enum';
import PatientsGroupsCreateBySelectionModal from '../PatientsGroupsCreate/PatientsGroupsCreateBySelectionModal';
import PatientsGroupsCreateByImportModal from '../PatientsGroupsCreate/PatientsGroupsCreateByImportModal';
import styles from './PatientsGroupsWrapper.module.scss';

interface ICustomButtons {
	reloadData: () => void;
}

const CustomButtons: React.FC<ICustomButtons> = ({ reloadData }) => {
	const [isCreateBySelectionOpen, setIsCreateBySelectionOpen] = useState(false);
	const [isCreateByImportOpen, setIsCreateByImportOpen] = useState(false);

	const handleOnSuccess = () => {
		setIsCreateBySelectionOpen(false);
		setIsCreateByImportOpen(false);
		reloadData();
	};

	return (
		<div className={styles.customButtonsWrapper}>
			<Button
				theme={Theme.BLUE}
				title='component.groupMsgs.createGroupBySelection'
				onClick={() => setIsCreateBySelectionOpen(true)}
			/>
			{isCreateBySelectionOpen && (
				<PatientsGroupsCreateBySelectionModal
					isOpen
					onClose={() => setIsCreateBySelectionOpen(false)}
					onSuccess={handleOnSuccess}
				/>
			)}
			<Button
				theme={Theme.GREEN}
				title='component.groupMsgs.createGroupByImport'
				onClick={() => setIsCreateByImportOpen(true)}
			/>
			{isCreateByImportOpen && (
				<PatientsGroupsCreateByImportModal
					isOpen
					onClose={() => setIsCreateByImportOpen(false)}
					onSuccess={handleOnSuccess}
				/>
			)}
		</div>
	);
};

const PatientsGroupsWrapper: React.FC = () => {
	const [getGroupsQuery, { data, isLoading }] = useLazyGroupsQuery();
	const { getGroups, getNextPage, page, setPage } = useGroups(getGroupsQuery);
	const {
		flatData,
		hasMoreData,
		loadData,
		setFilter,
		isLoading: isFlatDataLoading,
	} = useFlatData(
		getGroups,
		{
			data: data?.groups?.data,
			totalPages: data?.groups?.meta?.totalPages,
			page: data?.groups?.meta?.page,
		},
		page,
		setPage,
		{
			pagination: {
				take: 20,
			},
		},
	);

	return (
		<div className={styles.wrapper}>
			<PatientsGroupsFilter
				onFilter={setFilter}
				customButtons={<CustomButtons reloadData={loadData} />}
			/>
			<PatientsGroupsList
				isFlatDataLoading={isFlatDataLoading}
				isLoading={isLoading}
				hasMoreData={hasMoreData}
				flatData={flatData}
				onLoadMore={getNextPage}
				onRefresh={loadData}
			/>
		</div>
	);
};

export default PatientsGroupsWrapper;
